import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";

interface Props {
  memberId: string;
  gymId: string;
  scheduleId?: string;
  onSubmit: (data: { member_id: string; gym_id: string; content: string; schedule_id?: string }) => void;
  isPending: boolean;
}

export const ProfessorCommentForm = ({ memberId, gymId, scheduleId, onSubmit, isPending }: Props) => {
  const [content, setContent] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;
    onSubmit({ member_id: memberId, gym_id: gymId, content: content.trim(), schedule_id: scheduleId });
    setContent("");
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <Textarea
        placeholder="Escribir nota para el socio..."
        value={content}
        onChange={e => setContent(e.target.value)}
        className="min-h-[40px] text-sm flex-1"
      />
      <Button type="submit" size="icon" disabled={isPending || !content.trim()} className="shrink-0 self-end">
        <Send className="w-4 h-4" />
      </Button>
    </form>
  );
};
